import { render, staticRenderFns } from "./ButtonComponentCus.vue?vue&type=template&id=2df3e93a&scoped=true&"
import script from "./ButtonComponentCus.vue?vue&type=script&lang=js&"
export * from "./ButtonComponentCus.vue?vue&type=script&lang=js&"
import style0 from "./ButtonComponentCus.vue?vue&type=style&index=0&id=2df3e93a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df3e93a",
  null
  
)

export default component.exports